import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Barebone react web app.
        </p>
        <a
          className="App-link"
          href="https://github.com/gabepublic/cicd-github-react"
          target="_blank"
          rel="noopener noreferrer"
        >
          Github repo: cicd-github-react
        </a>
      </header>
    </div>
  );
}

export default App;
